import { IPagination } from 'app/types/common';

export interface INotificationConfigsState {
  readonly notificationConfigsById?: any;
  readonly notificationConfigIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectNotificationConfigLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddNotificationConfig?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationNotificationConfigIds?: string[];
  readonly currentNotificationConfigId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface INotificationConfigsSelector
  extends INotificationConfigsState {
  readonly currentNotificationConfig?: any;
  readonly currentFormNotificationConfig?: any;
  readonly notificationConfigsFilteredByOrganisationInSelectFormat?: any;
  readonly notificationConfigsByTagAndIdInSelectFormat?: any;
  readonly notificationConfigsByIdInSelectFormat?: any;
  readonly notificationConfigsFilteredByCompetitionInSelectFormat?: any;
  readonly notificationConfigsFilteredByIdInSelectFormat?: any;
}

export enum NotificationConfigsActionTypes {
  GET_ALL_NOTIFICATION_CONFIGS_REQUESTED = 'redux-app/notification-configs/GET_ALL_NOTIFICATION_CONFIGS_REQUESTED',
  GET_ALL_NOTIFICATION_CONFIGS_PENDING = 'redux-app/notification-configs/GET_ALL_NOTIFICATION_CONFIGS_PENDING',
  GET_ALL_NOTIFICATION_CONFIGS_SUCCESS = 'redux-app/notification-configs/GET_ALL_NOTIFICATION_CONFIGS_SUCCESS',
  GET_ALL_NOTIFICATION_CONFIGS_FAIL = 'redux-app/notification-configs/GET_ALL_NOTIFICATION_CONFIGS_FAIL',
  GET_NOTIFICATION_CONFIG_REQUESTED = 'redux-app/notification-configs/GET_NOTIFICATION_CONFIG_REQUESTED',
  GET_NOTIFICATION_CONFIG_PENDING = 'redux-app/notification-configs/GET_NOTIFICATION_CONFIG_PENDING',
  GET_NOTIFICATION_CONFIG_SUCCESS = 'redux-app/notification-configs/GET_NOTIFICATION_CONFIG_SUCCESS',
  GET_NOTIFICATION_CONFIG_FAIL = 'redux-app/notification-configs/GET_NOTIFICATION_CONFIG_FAIL',
  UPDATE_NOTIFICATION_CONFIG_REQUESTED = 'redux-app/notification-configs/UPDATE_NOTIFICATION_CONFIG_REQUESTED',
  UPDATE_NOTIFICATION_CONFIG_PENDING = 'redux-app/notification-configs/UPDATE_NOTIFICATION_CONFIG_PENDING',
  UPDATE_NOTIFICATION_CONFIG_SUCCESS = 'redux-app/notification-configs/UPDATE_NOTIFICATION_CONFIG_SUCCESS',
  UPDATE_NOTIFICATION_CONFIG_FAIL = 'redux-app/notification-configs/UPDATE_NOTIFICATION_CONFIG_FAIL',
  CREATE_NOTIFICATION_CONFIG_REQUESTED = 'redux-app/notification-configs/CREATE_NOTIFICATION_CONFIG_REQUESTED',
  CREATE_NOTIFICATION_CONFIG_PENDING = 'redux-app/notification-configs/CREATE_NOTIFICATION_CONFIG_PENDING',
  CREATE_NOTIFICATION_CONFIG_SUCCESS = 'redux-app/notification-configs/CREATE_NOTIFICATION_CONFIG_SUCCESS',
  CREATE_NOTIFICATION_CONFIG_FAIL = 'redux-app/notification-configs/CREATE_NOTIFICATION_CONFIG_FAIL',
  DELETE_NOTIFICATION_CONFIG_REQUESTED = 'redux-app/notification-configs/DELETE_NOTIFICATION_CONFIG_REQUESTED',
  DELETE_NOTIFICATION_CONFIG_PENDING = 'redux-app/notification-configs/DELETE_NOTIFICATION_CONFIG_PENDING',
  DELETE_NOTIFICATION_CONFIG_SUCCESS = 'redux-app/notification-configs/DELETE_NOTIFICATION_CONFIG_SUCCESS',
  DELETE_NOTIFICATION_CONFIG_FAIL = 'redux-app/notification-configs/DELETE_NOTIFICATION_CONFIG_FAIL',
  SELECT_NOTIFICATION_CONFIG_REQUESTED = 'redux-app/notification-configs/SELECT_NOTIFICATION_CONFIG_REQUESTED',
}

export default null;
